import { useTheme } from "@emotion/react";
import { Box, Card, Grid, Link, Typography, useMediaQuery } from "@mui/material";
import { createStyles, styled } from "@mui/material/styles";

const MAX_DEFAULT_WIDTH = 1200;
const MIN_DEFAULT_WIDTH = 330;

const Iconstyle= { width: '100%', maxWidth:'300px', height:"auto"}
const IconGridSx={ display: 'flex', justifyContent: 'center', alignItems: 'center', maxHeight: "250px"}

const StyledGrid = styled(Grid)(({ theme }) => (
    {
        maxWidth: MAX_DEFAULT_WIDTH,
        justifyContent: "center",
        flexDirection: "row",
        alignItems: "center",
        display: "flex",
        padding: '4px',
        width: "100%",
        minWidth: MIN_DEFAULT_WIDTH,
    }
));

const CTBox = (props) => {
    const theme = useTheme();
    const styles = createStyles({
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '2px',
      ...props.sx,
    });
  
    return <Box {...props} sx={styles}>{props.children}</Box>;
};

const StyledHeading = styled(Typography)(({ theme }) => (
    {
        fontFamily: "Montserrat, sans-serif",
        fontWeight: 700,
        letterSpacing: "0.1rem",
        mr: 1,
        color: theme.palette.primary.main,
    }
));

const StyledH2Heading = (props) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

    if (isSmallScreen) {
        return (
            <StyledHeading variant="h4" component="h1" gutterBottom>
                {props.children}
            </StyledHeading>
        );
    }
    return (
        <StyledHeading variant="h2" component="h1" gutterBottom>
            {props.children}
        </StyledHeading>
    );
}

const StyledH3Heading = (props) => {
    return (
        <StyledHeading variant="h3" component="h1" gutterBottom>
            {props.children}
        </StyledHeading>
    );
}

const StyledH4Heading = (props) => {
    return (
        <StyledHeading variant="h4" component="h1" gutterBottom>
            {props.children}
        </StyledHeading>
    );
}

const StyledH5Heading = (props) => {
   
    return (
        <StyledHeading variant="h5" component="h1" gutterBottom sx={props.sx}>
            {props.children}
        </StyledHeading>
    );
}

const StyledH6Heading = (props) => {
   
    return (
        <StyledHeading variant="h5" component="h1" gutterBottom>
            {props.children}
        </StyledHeading>
    );
}

const StyledCards = (props) => {

    return (
              <Card sx={{
                    minWidth: "120px",
                    maxWidth: "200px",
                    padding: "2px",
                    width: '100%',
                    position: 'relative',
                    overflow: 'hidden',
                }}>
                   {props.children} 
                </Card>
    )
}

const StyledLink = ({title, onClick}) => {

return (<Typography
          variant="body1"
          sx={{
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        }}>
        <Link sx={{ cursor: 'pointer' }} onClick={onClick}
        >{title}</Link>
        </Typography>
    );
}

export { StyledH3Heading, StyledH2Heading, StyledH5Heading, StyledH4Heading, StyledGrid, CTBox, IconGridSx, Iconstyle, StyledCards, StyledLink };